import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Divider, Drawer } from '@material-ui/core';
import { Profile, SocialMedia, SidebarNav } from './components';  // Language
import PersonIcon from '@material-ui/icons/Person';
import ImportantDevicesIcon from '@material-ui/icons/ImportantDevices';
import DescriptionIcon from '@material-ui/icons/Description';
import CodeIcon from '@material-ui/icons/Code';
import EmailIcon from '@material-ui/icons/Email';
import ImportContactsIcon from '@material-ui/icons/ImportContacts';
// import BookmarksIcon from '@material-ui/icons/Bookmarks';


const useStyles = makeStyles(theme => ({
  drawer: {
    width: 245,
    backgroundColor: '#84A086',
    [theme.breakpoints.up('lg')]: {
      height: 'calc(100% - 0px)'
    }
  },
  root: {
    backgroundColor: '#84a086',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2),
    paddingTop: 0,
    paddingBottom: 0
  },
  divider: {
    margin: "6px 0px",
    backgroundColor: "#748874"
  },
  nav: {
    marginBottom: theme.spacing(2)
  }
}));

const Sidebar = props => {
  const { open, variant, onClose, className, ...rest } = props;
  const classes = useStyles();
  const pages = [
    {
      title: 'About Me',
      href: '/aboutme',
      icon: <PersonIcon />
    }, {
      title: 'Portfolio',
      href: '/portfolio',
      icon: <ImportantDevicesIcon />
    },
    {
      title: 'Resume',
      href: '/resume',
      icon: <DescriptionIcon />
    },
    {
      title: 'Publications',
      href: '/publications',
      icon: <ImportContactsIcon />
    },
    {
      title: 'Code Snippets',
      href: '/javascript',
      icon: <CodeIcon />
    },
    // {
    //   title: 'My Quick Codes',
    //   href: '/quickcodes',
    //   submenu: [
    //     {
    //       title: 'JavaScript',
    //       href: '/javascript',
    //       icon: <BookmarksIcon />
    //     }
    //   ],
    //   icon: <CodeIcon />
    // },
    {
      title: 'Contact',
      href: '/contact',
      icon: <EmailIcon />
    }
  ];
  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}
    >
      {/* <Slide direction="right" in={true} mountOnEnter unmountOnExit> */}
      <div
        {...rest}
        className={clsx(classes.root, className)}
      >
        <Profile />
        <SocialMedia />
        <Divider className={classes.divider} />
        <SidebarNav
          className={classes.nav}
          pages={pages}
        />
        {/* <Language /> */}
      </div>
      {/* </Slide> */}
    </Drawer>
  );
};

Sidebar.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
};


export default Sidebar;